import type { ReactNode } from 'react';

export const symbol_vertical_distribute: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M110-80q-12.75 0-21.37-8.68Q80-97.35 80-110.18q0-12.82 8.63-21.32Q97.25-140 110-140h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q862.75-80 850-80H110Zm220-350q-20.83 0-35.42-14.62Q280-459.24 280-480.12q0-20.88 14.58-35.38Q309.17-530 330-530h300q20.83 0 35.42 14.62Q680-500.76 680-479.88q0 20.88-14.58 35.38Q650.83-430 630-430H330ZM110-820q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-880 110-880h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110Z"
		/>
	</svg>
);
